import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { formatAddress, formatDateTimeHuman, formatTime } from 'utils'
import GetDirections from 'components/GetDirections'

class CartSummary extends React.Component {
  render() {
    const { cart, event } = this.props

    const cartName = cart.data.first_name
      ? [cart.data.first_name, cart.data.last_name].join(' ')
      : cart.data.name

    return (
      <div className="event-summary">
        <div className="grid">
          {
            event &&
            <div className="grid__item lap-6-12">
              <div className="space--both-2">
                <h2 className="beta">
                  <FormattedMessage id="app.cart.summary.event.title" />
                </h2>
                <div>
                  <b>{event.title}</b>
                  <p>
                    {
                      !event.hideDuration &&
                      <FormattedMessage
                        id="app.cart.summary.event.duration"
                        values={{ duration: formatTime(event.duration) }}
                      />
                    }
                  </p>
                  <p>
                    {
                      !event.hidePrice &&
                      <FormattedMessage
                        id={ `app.cart.summary.event.price.${event.price.mode}${event.default_product_singular ? '.custom' : ''}` }
                        values={{
                          price: event.price.value,
                          currency: event.location.currency,
                          customText: event.default_product_singular,
                        }}
                      />
                    }
                  </p>
                </div>
              </div>
            </div>
          }

          {
            event &&
            <div className="grid__item lap-6-12">
              <div className="space--both-2">
                <h2 className="beta">
                  <FormattedMessage
                    id="app.cart.summary.location.title"
                  />
                </h2>
                <div>
                  <b>{event.location.title}</b>
                  <div>
                    { formatAddress(event.location.address) }
                  </div>
                  <GetDirections
                    coords={event.location.address.coords}
                  />
                </div>
              </div>
            </div>
          }

          {
            event &&
            <div className="grid__item lap-6-12">
              <div className="space--both-2">
                <h2 className="beta">
                  <FormattedMessage id="app.cart.summary.reservation.title" />
                </h2>
                <div>
                  <p>
                    <FormattedMessage
                      id="app.cart.summary.reservation.language"
                      values={{ language: cart.data.language }}
                    />
                  </p>
                  <p>
                    {
                      event.default_product_plural ? (
                        <FormattedMessage
                          id="app.cart.summary.reservation.guests.custom"
                          values={{ guests: cart.data.guests, customText: event.default_product_plural }}
                        />
                      ) : (
                        <FormattedMessage
                          id="app.cart.summary.reservation.guests"
                          values={{ guests: cart.data.guests }}
                        />
                      )
                    }
                  </p>
                  <p>
                    <FormattedMessage
                      id="app.cart.summary.reservation.datetime"
                      values={{ datetime: formatDateTimeHuman(
                        cart.data.start || event.start,
                        cart.data.ui_language,
                        cart.data.timezone || event.location.timezone) }}
                    />
                  </p>
                  {
                    cart.data.timezone && <p>
                      <FormattedMessage
                        id="app.cart.summary.reservation.timezone"
                        values={{ timezone: cart.data.timezone }}
                      />
                    </p>
                  }
                </div>
              </div>
            </div>
          }

          {
            this.props.showUserData &&
            <div className="grid__item lap-6-12">
              <div className="space--both-2">
                <h2 className="beta">
                  <FormattedMessage id="app.cart.summary.data.title" />
                </h2>
                <div>
                  <p>
                    <FormattedMessage
                      id="app.cart.summary.data.name"
                      values={{ name: cartName }}
                    />
                  </p>
                  <p>
                    <FormattedMessage
                      id="app.cart.summary.data.email"
                      values={{ email: cart.data.email }}
                    />
                  </p>
                  <p>
                    <FormattedMessage
                      id="app.cart.summary.data.phone"
                      values={{ phone: cart.data.phone }}
                    />
                  </p>
                  {
                    cart.data.last4 &&
                    <p>
                      <FormattedMessage
                        id="app.cart.summary.data.last4"
                        values={{ last4: cart.data.last4 }}
                      />
                    </p>
                  }
                </div>
              </div>
            </div>
          }
          {
            cart.data.note &&
            <div className="grid__item lap-6-12">
              <div className="space--both-2">
                <h2 className="beta">
                  <FormattedMessage id="app.cart.summary.notes.title" />
                </h2>
                <p>
                  {cart.data.note}
                </p>
              </div>
            </div>
          }
          {
            cart.data.status &&
            <div className="grid__item lap-6-12">
              <div className="space--both-2">
                <h2 className="beta">
                  <FormattedMessage id="app.reservation.status.title" />
                </h2>
                <p>
                  <FormattedMessage
                    id={`app.reservation.status.${cart.data.status}`}
                  />
                </p>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

CartSummary.propTypes = {
  cart: PropTypes.object.isRequired,
  event: PropTypes.object,
  showUserData: PropTypes.bool.isRequired,
}

CartSummary.defaultProps = {
  showUserData: true,
}

export default CartSummary
